import { DetailsView } from "@components/common/DetailsView";
import { DAP } from "@gen/dap/v1/dap_pb";
import { getDAP, updateDAP } from "@services/dap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { fields } from "./Fields";
import { Role } from "@gen/user/v1/user_pb";
import { useUserStore } from "@stores/userStore";
import { useToaster } from "@hooks/useToaster";
import { ConnectError } from "@connectrpc/connect";

export function DAPDetails() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [dap, setDap] = useState<DAP>();
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useUserStore();
  const { addToast } = useToaster();

  const fetchDap = async () => {
    if (!id) {
      return;
    }
    try {
      const { dap } = await getDAP(id, "");
      if (!dap) {
        return;
      }
      setDap(dap);
    } catch (error) {
      console.error("Error fetching DAP:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateDap = async (dap: DAP) => {
    if (!dap) {
      return;
    }
    try {
      const updatedDAP = await updateDAP(dap);
      setDap(updatedDAP);
    } catch (e) {
      if (e instanceof ConnectError) {
        addToast("error", e.rawMessage);
      }
    }
  };

  useEffect(() => {
    // oxlint-disable-next-line react-hooks/set-state-in-effect
    fetchDap();
  }, [id]);

  return (
    <DetailsView
      item={dap}
      title={`DAP ${dap?.number}`}
      fields={fields(t)}
      isLoading={isLoading}
      isEditable={!!user && [Role.ADMIN, Role.TRAVEL_AGENT].includes(user.role)}
      onSubmit={updateDap}
    />
  );
}
